export default __webpack_public_path__ + "static/media/user-role-not-assigned.2daa2a29.svg";